import React from 'react';
import { Container } from '@hpi-sox/hpstellar-core';
import { Typography } from '@hpi-sox/hpstellar-core/visId';

import withPageComponents from '../../../../page/components/with-page-components';
import useFooterLink from '../useFooterLink';
import { Helpers } from '../../../../core/src/helpers';

import './branded-overview.less';

const pdpOverview = ({ pdpFeatures, theme }) => {
    const { interceptClick } = useFooterLink();
    if (!pdpFeatures) {
        return null;
    }
    const { description } = pdpFeatures || {};
    const { backgroundImage } = theme || {};
    const hasOverview = description;

    return (
        <div className={`pdp-branded-overview`} id={hasOverview ? 'overview' : null} onClick={interceptClick}>
            <Container
                className="branded-overview-container"
                style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
            >
                <Typography
                    className="branded-overview-content"
                    variant="h2"
                    tag="div"
                    dangerouslySetInnerHTML={Helpers.createMarkup(description)}
                />
            </Container>
        </div>
    );
};

export default withPageComponents(pdpOverview, {
    components: ['productInitial', 'pdpFeatures'],
});
